import { Component, HostListener, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { HomeVideoService } from 'src/app/core/services/home-video.service';
import { BloqueVideo } from 'src/app/models/home-video';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-home-video',
  templateUrl: './home-video.component.html',
  styleUrls: ['./home-video.component.css']
})
export class HomeVideoComponent {
  videosOriginales: BloqueVideo[] = [];  // Lista completa
  videosFiltrados: BloqueVideo[] = [];   // Lista filtrada para mostrar
  pagina: number = 1;
  estado: string = 'activo';
  cargando: boolean = false;
  hayMas: boolean = true;
  terminoBusqueda: string = '';
  menuAbiertoId: number | null = null;

  constructor(private homeVideoService: HomeVideoService, private router: Router) {}

  ngOnInit(): void {
    this.cargarVideos();
  }

  parseTags(tags: string | string[]): string[] {
    if (!tags) return [];
    if (Array.isArray(tags)) return tags; // ya está en array
    try {
      return JSON.parse(tags); // si viene como string JSON
    } catch {
      return []; // si no se puede parsear
    }
  }
  

  cargarVideos(): void {
    if (this.cargando) return;

    this.cargando = true;
    this.homeVideoService.listarBloqueVideo(this.estado, this.pagina)
      .subscribe({
        next: (data) => {
          if (data.length > 0) {
            const procesados = data.map(video => ({
              ...video,
              tags: this.parseTags(video.tags)   // 👈 lo convertimos de una vez
            }));
        
            this.videosOriginales = [...this.videosOriginales, ...procesados];
            this.videosFiltrados = [...this.videosOriginales];
            this.pagina++;
          } else {
            this.hayMas = false;
          }
          this.cargando = false;
        },
        error: (err) => {
          console.error('Error cargando videos', err);
          this.cargando = false;
        }
      });
  }

  cambiarEstado(nuevoEstado: string): void {
    this.estado = nuevoEstado;
    this.pagina = 1;
    this.videosOriginales = [];
    this.videosFiltrados = [];
    this.hayMas = true;
    this.cargarVideos();
  }

  cambiarEstadoDesdeEvento(event: Event): void {
    const checked = (event.target as HTMLInputElement).checked;
    this.cambiarEstado(checked ? 'inactivo' : 'activo');  // 🔹 al revés
  }  

  editVideoBlock(id:number){
    this.router.navigate(['/form-video'], { queryParams: { id: id } });
  }

  extraerSrc(iframe: string): string {
    if (!iframe) return '';
    const match = iframe.match(/src="([^"]+)"/);
    return match ? match[1] : iframe;
  }

  filtrar(): void {
    const termino = this.terminoBusqueda.trim().toLowerCase();
  
    if (!termino) {
      // Si no hay término → mostrar originales
      this.videosFiltrados = [...this.videosOriginales];
      return;
    }
  
    // Filtro local
    const filtradosLocales = this.videosOriginales.filter(video => {
      const tags = Array.isArray(video.tags) ? video.tags : this.parseTags(video.tags);
      return video.titulo.toLowerCase().includes(termino) ||
             tags.some(tag => tag.toLowerCase().includes(termino));
    });
  
    if (filtradosLocales.length > 0) {
      this.videosFiltrados = filtradosLocales;
    } else {
      // Si no hay coincidencias locales → llamar API
      this.cargando = true;
      this.homeVideoService.getSearchCriteria(termino).subscribe({
        next: (response) => {
          console.log('Resultado búsqueda backend:', response);
  
          if (response.code === '200' && response.data) {
            const procesados = (Array.isArray(response.data) ? response.data : [response.data])
              .map(video => ({
                ...video,
                tags: this.parseTags(video.tags)
              }));
      
            this.videosFiltrados = procesados;
          } else {
            this.videosFiltrados = [];
          }
      
          this.cargando = false;
        },
        error: (err) => {
          console.error('Error búsqueda backend', err);
          Swal.fire('Error', 'No se pudo realizar la búsqueda global', 'error');
          this.cargando = false;
        }
      });
    }
  }
  

  confirmarEliminar(video: BloqueVideo): void {
    Swal.fire({
      title: '¿Deseas eliminar el módulo?',
      text: `"${video.titulo}" se eliminará permanentemente.`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Eliminar',
      cancelButtonText: 'Cancelar',
      confirmButtonColor: '#d33',
      cancelButtonColor: '#6c757d'
    }).then((result) => {
      if (result.isConfirmed) {
        this.eliminarVideo(video.id);
      }
    });
  }

  toggleMenu(id: number) {
    this.menuAbiertoId = this.menuAbiertoId === id ? null : id;
  }
  
  // cerrar menú si haces clic fuera
  @HostListener('document:click', ['$event'])
  onClickOutside(event: MouseEvent) {
    const target = event.target as HTMLElement;
    if (!target.closest('.relative')) {
      this.menuAbiertoId = null;
    }
  }

  eliminarVideo(id: number): void {
    Swal.fire({
      title: 'Eliminando...',
      didOpen: () => {
        Swal.showLoading();
      },
      allowOutsideClick: false,
      allowEscapeKey: false,
      showConfirmButton: false
    });

    this.homeVideoService.eliminarBloqueVideo(id).subscribe({
      next: () => {
        // Eliminamos del frontend
        this.videosOriginales = this.videosOriginales.filter(v => v.id !== id);
        this.videosFiltrados = this.videosFiltrados.filter(v => v.id !== id);

        Swal.fire('Eliminado', 'El módulo ha sido eliminado.', 'success');
      },
      error: (err) => {
        console.error('Error eliminando video', err);
        Swal.fire('Error', 'No se pudo eliminar el módulo.', 'error');
      }
    });
  }

  
}
